var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIlSent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 80,
    viewBox: "0 0 100 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h100v80H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#55BEF3",
    d: "M28.099 41.476l-7.625 13.206-9.497 2.545 3.641-23.145z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B5DBEE",
    d: "M19.601 45.671l4.21 8.116-12.834 3.44z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C6ECFF",
    d: "M94.734 19.705L26.33 77.375 6.66 3.965z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#55BEF3",
    d: "M89.905 21L18.306 47.43l-3.623-13.523z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIlSent);
export default __webpack_public_path__ + "static/media/il-sent.539c6fa4e26b31a92d957a09bf6843f2.svg";
export { ForwardRef as ReactComponent };